import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';

import theme from 'src/styles/theme';
import { YearSelect } from 'src/modules/common/components';

import RoadmapStep from '../RoadmapStep/RoadmapStep';
import { IRoadmapStep } from '../../types';

interface IRoadmapContainerProps {
  roadmapStepsData: IRoadmapStep[];
  years: number[];
  setSelectedYear: (year: number) => void;
  selectedYear: number;
}

const RoadmapContainer = (props: IRoadmapContainerProps) => {
  const { t } = useTranslation();
  const { roadmapStepsData, years, setSelectedYear, selectedYear } = props;
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        backgroundColor: theme.palette.colors.white,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: theme.palette.divider,
        padding: '2rem',
        borderRadius: '10px',
        marginTop: '1rem',
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
        <Box>
          <Typography variant="h5">
            {t('modules.home.sustainabilityReportingRoadmap.title')}
          </Typography>
          <Typography
            sx={{ color: theme.palette.colors.lightGrey }}
            fontSize="0.875rem !important"
            fontWeight={500}
            marginBottom={1}
          >
            {t('modules.home.sustainabilityReportingRoadmap.subtitle')}
          </Typography>
        </Box>
        <Box sx={{ flexShrink: '1' }}>
          <YearSelect years={years} year={selectedYear} setYear={setSelectedYear} />
        </Box>
      </Box>
      <RoadmapStep roadmapStepsData={roadmapStepsData} />
    </Box>
  );
};

export default RoadmapContainer;
